<template>
  <v-container>
      <router-link v-for="btn in buttons" :key="btn.id" :to="btn.link">
          <v-btn text>
              {{btn.text}}
          </v-btn>
      </router-link>
  </v-container>
</template>

<script>
export default {
    data:function () {
        return{
            buttons:[
                {
                    id:0,
                    text:'Översikt',
                    link:'/dashboard'
                },
                {
                    id:1,
                    text:'Scheman',
                    link:'/account/schedules'
                },
                {
                    id:2,
                    text:'Kommentarer',
                    link:'/account/comments'
                },
                {
                    id:4,
                    text:'Inställningar',
                    link:'/account/settings'
                },
            ]
        }
    }
}
</script>

<style>

</style>